import { useQuery } from '@tanstack/react-query';

import { useErrorEffect } from '@/shared/lib/errors';
import { useAppSelector } from '@/shared/lib/redux';

import { API_URLS } from '@/shared/api/main';

import { getMenuCounters } from '@/entities/menu-counters/api/getMenuCounters';

/**
 * Хук для агрегирующих счётчиков навигационного меню (бейджи навбара + колокольчик).
 * userId в ключе обязателен для изоляции данных между аккаунтами (мультитенантность):
 * без него после смены аккаунта React Query вернёт счётчики предыдущего пользователя.
 */
export const useGetMenuCounters = () => {
  const currentUserId = useAppSelector(state => state.user.data.id);

  const {
    data: menuCounters,
    error,
    isLoading
  } = useQuery({
    queryKey: [API_URLS.menuCounters, currentUserId],
    queryFn: getMenuCounters
  });

  useErrorEffect(error);

  const notificationsUnviewedCount = menuCounters?.notifications_unviewed || 0;

  return { menuCounters, notificationsUnviewedCount, isLoading };
};
